import { defineMessages } from 'react-intl';

export default defineMessages({
  waitForCf: {
    id: 'webCollaboration.waitForCf',
    defaultMessage: 'In attesa del consulente finanziario...',
  },
  waitForProspect: {
    id: 'webCollaboration.waitForProspect',
    defaultMessage: 'In attesa del prospect...',
  },
  connecting: {
    id: 'webCollaboration.connecting',
    defaultMessage: 'In connessione...',
  },
  closeCallButton: {
    id: 'webCollaboration.closeCallButton',
    defaultMessage: 'Chiudi chiamata',
    description: 'Label for the "close call" button',
  },
  callButton: {
    id: 'webCollaboration.callButton',
    defaultMessage: 'Chiamata',
    description: 'Label for the "close call" button',
  },
  reconnect: {
    id: 'webCollaboration.reconnect',
    defaultMessage: 'Riconettiti alla chiamata',
    description: 'Label for reconnect to call',
  },
  microphoneButton: {
    id: 'webCollaboration.microphoneButton',
    defaultMessage: 'Microfono',
    description: 'Label for the "close call" button',
  },
  webcamButton: {
    id: 'webCollaboration.webcamButton',
    defaultMessage: 'Webcam',
    description: 'Label for the "close call" button',
  },
  sharedVideoButton: {
    id: 'webCollaboration.sharedVideoButton',
    defaultMessage: 'Condividi',
    description: 'Label for the "close call" button',
  },
  waitForReconnectingTitle: {
    id: 'webCollaboration.waitForReconnectingTitle',
    defaultMessage: 'Chiamata in attesa',
  },
  waitForCfReconnecting: {
    id: 'webCollaboration.waitForCfReconnecting',
    defaultMessage:
      'Siamo in attesa che il consulente finanziario si riconnetta alla chiamata...',
  },
  waitForProspectReconnecting: {
    id: 'webCollaboration.waitForProspectReconnecting',
    defaultMessage:
      'Siamo in attesa che il prospect si riconnetta alla chiamata...',
  },
  notConnected: {
    id: 'webCollaboration.notConnected',
    defaultMessage: 'Problemi di connessione.',
  },
  mifidCompleted: {
    id: 'webCollaboration.mifidCompleted',
    defaultMessage:
      'Il questionario MiFid è stato completato con successo e la chiamata è stata chiusa.',
  },
  mifidCompletedTitle: {
    id: 'webCollaboration.mifidCompletedTitle',
    defaultMessage: 'MiFid completato',
  },
  sharingBlockDialog: {
    id: 'webCollaboration.sharingBlockDialog',
    defaultMessage:
      'Per poter compilare il questionario è necessario condividere lo schermo.',
  },
  callEnded: {
    id: 'webCollaboration.callEnded',
    defaultMessage: 'Chiamata terminata',
  },
  roomExpired: {
    id: 'webCollaboration.roomExpired',
    defaultMessage: 'Spiacenti, questo link è scaduto e non è più utilizzabile.',
  },
});
